import { render, staticRenderFns } from "./Product_Form.vue?vue&type=template&id=831a633e&scoped=true&"
import script from "./Product_Form.vue?vue&type=script&lang=js&"
export * from "./Product_Form.vue?vue&type=script&lang=js&"
import style0 from "./Product_Form.vue?vue&type=style&index=0&id=831a633e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831a633e",
  null
  
)

export default component.exports